<template>
    <header class="header">
        <div class="header-container">
            <div class="header-left">
                <div class="logo">
                    <a href="/">
                        <img src="/img/logo.svg" alt="logo (2)">
                    </a>
                </div>
                <div class="lang">
                    <ul class="language-select">
                        <li :class="{active : lang === 'ru'}" @click="setLang('ru')">RU</li>
                        <li :class="{active: lang === 'en'}" @click="setLang('en')">EN</li>
                        <li :class="{active: lang === 'uk'}" @click="setLang('uk')">UA</li>
                    </ul>
                </div>
                <nav class="header-menu" id="menu">
                    <ul class="header-items">
                        <li><a href="/rooms">{{$t('navigation.rooms')}}</a></li>
                        <li><a href="/food-hub">{{$t('navigation.food')}}</a></li>
                        <li><a href="https://conference.gagarinn.com/" class="conference">{{$t('navigation.confService')}}</a></li>
                        <!--<li><a href="">{{$t('navigation.service')}}</a></li>
                        <li><a href="#">{{$t('navigation.news')}}</a></li>
                        <li><a href="#">{{$t('navigation.career')}}</a></li>-->
                        <li><a href="/contact">{{$t('navigation.contact')}}</a></li>
                        <li style="visibility: hidden"><a href="/faq">{{$t('navigation.faq')}}</a></li>
                    </ul>
                </nav>
            </div>
            <div class="header-right">
                <a target="_blank" href="viber://contact?number=%2B380737744473" class="viber">
                  <img src="/img/viber.svg" alt="viber">
                </a>
                <div class="header-phone ph-phone2">
                    <a href="tel:+380737744473">+38 (073) 77 444 73</a>
                </div>
                <div class="header-phone ph-phone1">
                    <a href="tel:0487744473" class="binct-phone-number-1">+38 (048) 77 444 73</a>
                </div>
<!--                <a target="_blank" href="https://roundme.com/tour/291613/view/919413/" class="fa tour3d" style="color: #DEDEDF; font-family: UniNeueBold, sans-serif; font-size: 0.833vw;">3D</a>-->
                <a target="_blank" href="https://www.facebook.com/HotelGagarinn" class="fa facebook">
                    <img src="/img/facebook.svg" alt="facebook">
                </a>
                <a target="_blank" href="https://www.instagram.com/gagarinn_hotel" class="fa instagram">
                    <img src="/img/instagram.svg" alt="instagram">
                </a>
<!--                <a target="_blank"-->
<!--                   href="https://www.tripadvisor.com/Hotel_Review-g295368-d6700785-Reviews-Gagarinn-Odessa_Odessa_Oblast.html"-->
<!--                   class="fa tripadvisor">-->
<!--                    <img class="trip" src="/img/tripadvisor.svg" alt="tripadvisor">-->
<!--                </a>-->
                <div class="header-btn-wrap">
                    <a class="header-btn" id="header-btn" :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]">{{$t('booking.title')}}</a>
                </div>
            </div>
        </div>
        <div class="m-header-container">

            <div class="m-header-left">
                <div class="m-header-logo">
                    <img src="/img/mob-logo.svg" alt="logo">
                </div>
            </div>

            <div class="m-header-right">
                <div class="m-header-phone ph-phone1">
                    <button :class="{active: phones === true}" @click="setPhones(!phones)">&#9660;</button>
                    <a href="tel:0737744473" class="active binct-phone-number-1">+38 (073) 77 444 73</a>
                    <div v-if="phones" class="additional">
                      <a href="tel:0487744473" class="active binct-phone-number-1">+38 (048) 77 444 73</a>
                    </div>
                </div>
                <div class="m-lang">
                    <ul class="m-language-select">
                        <li :class="{active : lang === 'ru'}" @click="setLang('ru')">RU</li>
                        <li :class="{active: lang === 'en'}" @click="setLang('en')">EN</li>
                        <li :class="{active: lang === 'uk'}" @click="setLang('uk')">UA</li>
                    </ul>
                </div>
                <div class="burger-menu md-trigger" data-modal="modal-sidebar">
                    <div class="menu-trigger second">
                        <span class="line line-1"></span>
                        <span class="line line-2"></span>
                        <span class="line line-3"></span>
                    </div>
                </div>
            </div>
        </div>
    </header>

</template>

<script>
    export default {
        name: 'TopHeader',
      data() {
        return {
          phones: false,
        };
      },
        computed: {
            lang: function() {
                return this.$root.locale;
            },
            phones: false
        },
        methods: {
            setLang(lang) {
                localStorage.setItem('language', lang);
                this.$root.setLocale(lang);
            },
            setPhones(val) {
              this.phones = val;
            }
        }
    }
</script>
